import { z } from 'zod'

export const unReadRemindItemSchema = z.object({
  quantity: z.number()
})

export interface UnReadRemindItem
  extends z.infer<typeof unReadRemindItemSchema> {}
